<div class="card" *ngIf="guardian">
    <div class="card-header">
        <h3 class="text-center"> Reports</h3>
    </div>
    <div class="card-body">

<div class="table-responsive" *ngIf="guardian.students.length>0">
    <table datatable [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
        <thead>
        <tr><th>Name</th><th> Reports</th></tr>
      </thead>
        <tbody>
        <tr *ngFor="let student of guardian.students; index as myCount">
          <td><i class="fa fa-graduation-cap"></i> {{student.fullname}}</td>
          <td> <a [routerLink]="['/report/guardian/student',server_user_id,student.server_user_id]"><i class="fa fa-bar-chart-o"></i> </a></td>
        </tr>
      </tbody>
</table>
</div>
<div *ngIf="guardian.students.length<=0" class="alert alert-info">
Shows Reports. No reports found.
</div>
</div>
</div>
<app-spinner *ngIf="guardian"> </app-spinner>
